<script setup lang="ts">
import type { DeviceModel } from '@rfc/rfc-components-library/types'
import DeviceOrganizationsActions from './DeviceOrganizationsActions.vue'

type Props = {
    data?: Partial<DeviceModel>
}
defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
defineEmits<Emits>()
</script>

<template>
    <DeviceOrganizationsActions :data="data" @refresh="$emit('refresh')" />
</template>
